<div class="ag-cell-editor fx-layout-row fx-justify-space-between fx-align-center fx-gap-5">
  <input #inputText [formControl]="control" matInput class="mat-input-element ag-input-field-input" type="text"
         (focusin)="fullRowEdit && inputText.select()"
         (beforeinput)="validateKeypressEvent($event)"
         (paste)="validatePasteEvent($event)"/>

  @if (control.invalid) {
    <div>
      <mat-icon fontSet="mdi" fontIcon="mdi-help-circle" aria-hidden="true" class="tooltip-icon" [matTooltip]="errorTooltip"></mat-icon>
    </div>
  }
  @if (!fullRowEdit) {
    <div>
      <mat-icon fontSet="mdi" fontIcon="mdi-check" aria-hidden="true" (click)="stopEditing()"></mat-icon>
    </div>
  }
</div>
